var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPreviewFill = function SvgPreviewFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h14q.824 0 1.413.587Q21 4.176 21 5v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm0-2h14V7H5zm7-2q-2.05 0-3.662-1.113A6.37 6.37 0 0 1 6 13a6.37 6.37 0 0 1 2.338-2.887Q9.95 9 12 9t3.662 1.113A6.37 6.37 0 0 1 18 13a6.37 6.37 0 0 1-2.338 2.887Q14.05 17 12 17m0-2.5q-.625 0-1.062-.437A1.45 1.45 0 0 1 10.5 13q0-.625.438-1.062A1.45 1.45 0 0 1 12 11.5q.624 0 1.063.438.437.437.437 1.062 0 .624-.437 1.063A1.45 1.45 0 0 1 12 14.5m0 1q1.05 0 1.775-.725T14.5 13t-.725-1.775T12 10.5t-1.775.725T9.5 13t.725 1.775T12 15.5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPreviewFill);
export { ForwardRef as ReactComponent };